import React from "react";
import "../tracker/tracker.css";
import axios from "axios";
import jQuery from "jquery";
import Header from "../tracker/common/header";
import Footer from "../tracker/common/footer";
import { BrowserRouter, Switch, Route, Link } from "react-router-dom";

class VaccineDataIN extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      apptitle: this.props.apptitle,
      vacToday: "",
      vacTotal: "",
      vacMale: "",
      vacFemale: "",
      vacOthers: "",
      vacCovaxin: "",
      vacCovisheild: ""
    };
  }

  componentDidMount = (e) => {
    //e.preventDefault();

    axios
      .get(
        "https://api.cowin.gov.in/api/v1/reports/v2/getPublicReports",
        this.state
      )
      .then((res) => {
        if (res.data) {
          // console.log(res.data);
          //console.log(res.data.topBlock);
          //console.log(res.data.topBlock.vaccination);
          this.setState({
            vacToday: res.data.topBlock.vaccination.today,
            vacTotal: res.data.topBlock.vaccination.total,
            vacMale: res.data.topBlock.vaccination.male,
            vacFemale: res.data.topBlock.vaccination.female,
            vacOthers: res.data.topBlock.vaccination.others,
            vacCovaxin: res.data.topBlock.vaccination.covaxin,
            vacCovisheild: res.data.topBlock.vaccination.covishield
          });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  render() {
    return (
      <section className="tracker-section">
        <Header title={this.props.apptitle} />

        <div className="container bodyContainer">
          <div className="details-column row">
            <div className="col-12">
              <label>Vaccination Done Till Today</label>
              <br />
            </div>
            <div className="col-12">
              <div className="updated-time-column">
                <p>
                  <i className="fa fa-bell"></i>&nbsp;Vaccinations Done Today -
                  &nbsp;
                  <strong>{this.state.vacToday}</strong>
                  &nbsp;
                </p>
              </div>
            </div>

            <div className="col-12 stateTextColumn text-center">
              <br />
              <Link to="/vacStatedata">View State Wise Vaccination Data</Link>
              <br />
              <br />
            </div>
          </div>
          <div className="details-column row">
            <div className="col-6">
              <div className="col-inner">
                <p>Total</p>
                <h2>
                  <strong>
                    <span id="TotalVac">{this.state.vacTotal}</span>
                  </strong>
                </h2>
              </div>
            </div>
            <div className="col-6">
              <div className="col-inner">
                <p>Male</p>
                <h2>
                  <strong>
                    <span id="VacMale">{this.state.vacMale}</span>
                  </strong>
                </h2>
              </div>
            </div>
          </div>
          <div className="details-column row">
            <div className="col-6">
              <div className="col-inner">
                <p>Female</p>
                <h2>
                  <strong>
                    <span id="VacFemale">{this.state.vacFemale}</span>
                  </strong>
                </h2>
              </div>
            </div>
            <div className="col-6">
              <div className="col-inner">
                <p>Others</p>
                <h2>
                  <strong>
                    <span id="VacOthers">{this.state.vacOthers}</span>
                  </strong>
                </h2>
              </div>
            </div>
          </div>
          <div className="details-column row">
            <div className="col-6">
              <div className="col-inner blue-col">
                <p>Covaxin</p>
                <h2>
                  <strong>
                    <span id="VacCovaxin">{this.state.vacCovaxin}</span>
                  </strong>
                </h2>
              </div>
            </div>
            <div className="col-6">
              <div className="col-inner green-col">
                <p>Covishield</p>
                <h2>
                  <strong>
                    <span id="VacCovisheild">{this.state.vacCovisheild}</span>
                  </strong>
                </h2>
              </div>
            </div>
          </div>
          <div className="row">
            <Footer />
          </div>
        </div>
      </section>
    );
  }
}

export default VaccineDataIN;
